import React from 'react';
import { motion } from 'framer-motion';
import { Product, Batch } from './mockData';
import { ChevronRight, ChevronLeft, ArrowRight } from 'lucide-react';
interface ChargeListProps {
  product: Product;
  batches: Batch[];
  visibleColumns: string[];
  onBack: () => void;
  onSelectBatch: (batch: Batch) => void;
}
export function ChargeList({
  product,
  batches,
  visibleColumns,
  onBack,
  onSelectBatch
}: ChargeListProps) {
  const show = (key: string) => visibleColumns.includes(key);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="w-full px-4 sm:px-6 lg:px-10 2xl:px-16 pb-12" data-id="element-210">
      {/* Breadcrumb */}
      <nav className="flex items-center text-sm text-gray-500 mb-6" data-id="element-211">
        <button onClick={onBack} className="hover:text-[#E87722] flex items-center transition-colors" data-id="element-212">
          <ChevronLeft className="w-4 h-4 mr-1" data-id="element-213" />
          Produkte
        </button>
        <ChevronRight className="w-4 h-4 mx-2 text-gray-400" data-id="element-214" />
        <span className="font-medium text-gray-900" data-id="element-215">{product.name}</span>
      </nav>

      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-216">
        <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center bg-gray-50/50" data-id="element-217">
          <div data-id="element-218">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-219">
              Chargen für {product.name}
            </h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-220">
              {batches.length} Einträge gefunden
            </p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-221">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-222">
            <thead className="bg-gray-50" data-id="element-223">
              <tr data-id="element-224">
                {show('batchNumber') && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-225">
                    Chargen-Nr.
                  </th>}
                {show('productionDate') && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-226">
                    Produktionsdatum
                  </th>}
                {show('status') && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-227">
                    Status
                  </th>}
                <th className="relative px-6 py-3" data-id="element-228">
                  <span className="sr-only" data-id="element-229">Aktion</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-230">
              {batches.map(batch => <tr key={batch.id} onClick={() => onSelectBatch(batch)} className="hover:bg-gray-50 cursor-pointer transition-colors group" data-id="element-231">
                  {show('batchNumber') && <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-232">
                      {batch.batchNumber}
                    </td>}
                  {show('productionDate') && <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-233">
                      {batch.productionDate}
                    </td>}
                  {show('status') && <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-234">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${batch.status === 'Abgeschlossen' ? 'bg-green-100 text-green-800' : batch.status === 'Bereit zum Verpacken' ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-235">
                        {batch.status}
                      </span>
                    </td>}
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-236">
                    <button className="text-gray-400 group-hover:text-[#E87722] transition-colors flex items-center justify-end w-full" data-id="element-237">
                      Details <ArrowRight className="w-4 h-4 ml-1" data-id="element-238" />
                    </button>
                  </td>
                </tr>)}
              {batches.length === 0 && <tr data-id="element-239">
                  <td colSpan={visibleColumns.length + 1} className="px-6 py-8 text-center text-sm text-gray-500" data-id="element-240">
                    Keine Chargen für die aktuellen Filter gefunden.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}